/* eslint-disable radix */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
export const formatTime = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  return (
    `${[year, month, day].map(formatNumber).join('/')
    } ${
      [hour, minute, second].map(formatNumber).join(':')}`
  );
};

export const formatNumber = (n) => {
  n = n.toString();
  return n[1] ? n : `0${n}`;
};

export const formatDate = (time) => {
  const hour = parseInt(time / 3600);
  const minute = parseInt((time - hour * 3600) / 60);
  const second = parseInt(time - hour * 3600 - minute * 60);

  let text = '';
  if (hour < 10) {
    text += '0';
  }
  text += String(hour);
  text += ':';

  if (minute < 10) {
    text += '0';
  }
  text += String(minute);
  text += ':';

  if (second < 10) {
    text += '0';
  }
  text += String(second);

  return text;
};

export const formatDay = (time) => {
  if (!time) return '';
  time = time / 1000;
  const day = parseInt(time / (3600 * 24));
  time = time - day * (3600 * 24);
  const hour = parseInt(time / 3600);
  const minute = parseInt((time - hour * 3600) / 60);

  let text = '';
  if (day > 0) {
    text += `${day}天`;
  }
  if (hour < 10) {
    text += '0';
  }
  text += String(hour);
  text += '时';

  if (minute < 10) {
    text += '0';
  }
  text += String(minute);
  text += '分';

  return text;
};

export const maxLenText = function (text, maxLen) {
  if (!text) {
    return '';
  }

  const len = text.length;
  if (len < maxLen) {
    return text;
  }

  return text.substring(0, maxLen);
};

export const formatInterval = (interval) => {
  // 时间戳转时间
  if (!interval) {
    return '';
  }

  const now = new Date(interval);
  const year = now.getFullYear();
  let month = now.getMonth() + 1;
  if (month < 10) {
    month = `0${String(month)}`;
  }

  let date = now.getDate();
  if (date < 10) {
    date = `0${String(date)}`;
  }

  let hour = now.getHours();
  if (hour < 10) {
    hour = `0${String(hour)}`;
  }

  let minute = now.getMinutes();
  if (minute < 10) {
    minute = `0${String(minute)}`;
  }

  let second = now.getSeconds();
  if (second < 10) {
    second = `0${String(second)}`;
  }

  return (
    `${year
    }-${
      month
    }-${
      date
    } ${
      hour
    }:${
      minute
    }:${
      second}`
  );
};

export const getAmountInt = function (amount) {
  return String(parseInt(amount / 100));
};

export const gtAmountDecimal = function (amount) {
  const decimal = amount % 100;
  if (decimal === 0) {
    return '';
  } if (decimal < 10) {
    return `0${parseInt(decimal)}`;
  }
  return String(parseInt(decimal));
};

export const getAmountText = function (amount) {
  const decimal = this.gtAmountDecimal(amount);
  if (decimal.length === 0) {
    return `￥${this.getAmountInt(amount)}`;
  }
  return `￥${this.getAmountInt(amount)}.${decimal}`;
};

export const positiveIntInput = function (value) {
  if (value) {
    value = value.toString();
    if (value.length === 1) {
      value = value.replace(/[^1-9]/g, '');
    }
    if (value) {
      value = value.replace(/\D/g, '');
      if (value) {
        value = parseInt(value);
        return value;
      }
    }
  }
  return '';
};

export const positiveFloatInput = function (value) {
  value = value.toString();
  if (value.length === 2) {
    if (value === '00') value = '0';
    if (value.charAt(0) === '0' && /[1-9]/.test(value.charAt(1))) {
      value = value.charAt(1);
    }
  }
  value = value.match(/\d+(\.\d{0,2})?/)
    ? value.match(/\d+(\.\d{0,2})?/)[0]
    : '';
  return value;
};

export const joinPath = function (path, params) {
  if (!params) {
    return path;
  }
  let newPath = path;
  if (newPath.indexOf('?') < 0) {
    newPath += '?';
  }
  for (let i = 0; i < params.length; i++) {
    const param = params[i];
    if (i > 0 || newPath.endsWith('?') === false) {
      newPath += '&';
    }

    const item = `${param.key}=${param.value}`;
    newPath += item;
  }
  return newPath;
};

export const getImgParam = (name, str) => {
  if (!str) return null;
  const regExp = `(${name})=([0-9]+)`;
  const reg = new RegExp(regExp, 'i');
  const r = str.match(reg);
  if (r !== null) return r[2];
  return null;
};

export const addUrlQuery = (_url, key, value) => {
  const param = `${key}=${value}`;
  _url += (_url.split('?')[1] ? '&' : '?') + param;
  return _url;
};

export const calcRate = (src) => {
  const ImgWidth = getImgParam('width', src);
  const ImgHeight = getImgParam('height', src);
  if (ImgWidth && ImgHeight) {
    return ImgWidth / ImgHeight;
  }
  return 1;
};

export const getMediaSize = src => new Promise((resolve, reject) => {
  fetch(src).then(res => res.blob())
    .then((data) => {
      resolve(data.size);
    });
});

export function getCurrentWindow() {
  let currentWindow = window;
  if (window.iframeWindow) {
    currentWindow = window.iframeWindow;
  }
  return currentWindow;
}

// 将rem长度转化为以px为单位的长度的数字部分
export function rem2px(rem) {
  if (!rem) {
    return 0;
  }
  const currentWindow = getCurrentWindow();
  const currentDocument = currentWindow.document;
  if (!currentDocument) {
    return;
  }
  const currentHtml = currentDocument.getElementsByTagName('html')[0];
  if (!currentHtml) {
    return;
  }
  const { fontSize } = currentHtml.style;
  const fontSizeNum = parseFloat(fontSize) || 0;
  const remNum = parseFloat(rem) || 0;

  return remNum * fontSizeNum;
}
